import { withCommonMoveSetup } from './moveDecorator.js';

/**
 * Custom implementation for Mud Sport.
 * Field effect: halves the base power of Electric-type moves for all Pokémon until
 * the user switches out or faints.
 */
export default class MudSport {
    static customMoveLogic(battleStateMachine, move, attacker, defender) {
        battleStateMachine.addFieldEffect('mud_sport', attacker);
        battleStateMachine.context.actions.push(
            battleStateMachine.ag.readText(`Electric's power was weakened!`, { delay: 50 })
        );
    }

    static setUpBattleActions = withCommonMoveSetup(MudSport.customMoveLogic);
}
